import { GridFilterItem } from '@mui/x-data-grid-pro';
import {
  isoToMuiDatepickerDate,
  startOfDayToUtcMillis,
} from 'shared/utils/date/dates';

const isInRange = (
  timestamp: number,
  start: number | null,
  end: number | null
): boolean => {
  const afterStart = start === null || timestamp >= start;
  const beforeEnd = end === null || timestamp <= end;

  return afterStart && beforeEnd;
};

export const getDateRangeFilterFn = (
  filterItem: GridFilterItem,
  timezone: string
): ((value: Date | null) => boolean) | null => {
  const range = filterItem.value ?? { start: null, end: null };
  const { start, end } = range;
  if (start === null && end === null) {
    return null;
  }

  return (value: Date | null): boolean => {
    if (!value) return false;

    const cellDate = isoToMuiDatepickerDate(value.toISOString(), timezone);
    if (!cellDate) return false;

    const onDayStart = startOfDayToUtcMillis(cellDate);
    if (!onDayStart) return false;

    return isInRange(onDayStart, start, end);
  };
};
